import React, { FC, useContext, useEffect, useState } from 'react';
import { TableCellEnd, TableCellMiddle, TableCellStart, TableRowCustom, TableRowCollapse, ButtonCollapse } from 'components';
import { TablePaymentReturn } from 'components/TableCollapse';
import { format } from 'date-fns';
import NumberFormat from 'components/NumberFormat';
import { makeStyles, Typography, Theme, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import useRouter from 'hooks/useRouter';
import PaymentStatus from 'typings/enum/PaymentStatus';
import PaymentMethod from 'typings/enum/PaymentMethod';
import { BLUE_PRIMARY, CONFIRMATION_COLOR, PENDING_COLOR, WHITE } from 'constants/colors';
import { DescriptionOutlined, Edit } from '@material-ui/icons';
import { CurrentUserContext } from 'contexts/CurrentUserContext';
import useRole from 'hooks/useRole';
import TypeUser from 'typings/enum/TypeUser';

const useStyles = makeStyles((theme: Theme) => ({
  accept: {
    padding: '5px 12px 5px 12px',
    borderRadius: '100px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '22px',
    color: WHITE,
    background: BLUE_PRIMARY,
    textAlign: 'center',
    width: 120
  },
  unpaid: {
    padding: '5px 12px 5px 12px',
    borderRadius: '100px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '22px',
    color: WHITE,
    background: PENDING_COLOR,
    textAlign: 'center',
    width: 120
  },
  paid: {
    padding: '5px 12px 5px 12px',
    borderRadius: '100px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '22px',
    color: WHITE,
    background: CONFIRMATION_COLOR,
    textAlign: 'center',
    width: 120
  },
  cancel: {
    background: '#ccc',
    color: '#000'
  },
  totalRow: {
    // backgroundColor: '#f5f5f5',
    '& .MuiTableCell-root': {
      fontWeight: 'bold'
      // borderTop: '2px solid #ddd'
    }
  },
  blurredText: {
    // filter: 'blur(2px)',
    fontSize: '12px',
    color: '#888',
    marginTop: '2px'
  },
  tableRow: {
    backgroundColor: '#FFFAEF',

    '&  .MuiTableCell-root': {
      borderTop: '1px solid #E4AE42',
      borderBottom: '1px solid #E4AE42'
    }
  }
}));

interface Props {
  index: number;
  invoicePayment: InvoicePaymentModel;
  invoicePaymentReturn: InvoiceReturnModel[];
  isLoading: boolean;
  isLoadingCollapse: boolean;
  indexCollapse: number;
  openCollapse: boolean;
  handleOpenCollapse: React.MouseEventHandler;
  handleAction: (isOpen: boolean, id: number) => void;
}

const BodyRow: FC<Props> = props => {
  const classes = useStyles();
  const { currentUser } = useContext(CurrentUserContext);
  const { handleAction, invoicePayment, isLoading, invoicePaymentReturn, isLoadingCollapse, indexCollapse, openCollapse, handleOpenCollapse } = props;
  const { history } = useRouter();
  const { index } = props;
  const isSuperAdmin = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.SUPERADMIN]
  });

  const isFinance = useRole({
    type: (currentUser && currentUser.type) || TypeUser.ADMIN04,
    allowed: [TypeUser.ADMIN04]
  });

  const autorisasiDataList = Array.isArray(invoicePayment.autorisasiData)
    ? invoicePayment.autorisasiData
    : invoicePayment.autorisasiData
    ? (Object.values(invoicePayment.autorisasiData) as any[])
    : [];
  const validAutorisasiDataList = autorisasiDataList.filter((v: any) => v && typeof v === 'object' && Object.keys(v).length > 0);

  const handleLink = () => {
    history.push(`/pembayaran-penjualan/${invoicePayment.id}`);
  };

  useEffect(() => {
    if (!invoicePayment || !invoicePaymentReturn) {
      return;
    }

    // if (invoicePayment.paymentMethod === 'Return' && invoicePayment.useReturn && invoicePaymentReturn[0]) {
    //   invoicePaymentReturn[0].totalPrice = invoicePayment.totalReturn || 0;
    // }
  }, [openCollapse, invoicePayment, invoicePaymentReturn]);

  const isHidden = () => {
    if (invoicePayment.reject) {
      if (!!validAutorisasiDataList.length) {
        const financ = validAutorisasiDataList.find((v: any) => v.role === 'ADMIN_KEUANGAN')?.status;
        const superAdmmin = validAutorisasiDataList.find((v: any) => v.role === 'SUPERADMIN')?.status;
        if (financ === 'REJECT' && superAdmmin === 'PENDING') {
          return true;
        }
        return false;
      }
    }
    return false;
  };

  return (
    <>
      <TableRowCustom
        className={
          invoicePayment.autorisasi === true &&
          invoicePayment.InvoicePaymentMultiple &&
          invoicePayment.InvoicePaymentMultiple.some(
            item => item.dueDate && item.orderDateInvoice && new Date(item.dueDate) >= new Date(item.orderDateInvoice)
          )
            ? classes.tableRow
            : ''
        }
      >
        <TableCellStart>
          <ButtonCollapse
            name=''
            isLoading={isLoading}
            isOpen={openCollapse && invoicePayment.id === indexCollapse}
            useCollapse={true}
            handleOpenCollapse={handleOpenCollapse}
            handleNameLink={handleLink}
          />
        </TableCellStart>
        <TableCellMiddle onClick={handleLink}>{isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : index + 1}</TableCellMiddle>
        <TableCellMiddle onClick={handleLink}>
          {isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : invoicePayment.paymentNumber}
        </TableCellMiddle>
        <TableCellMiddle onClick={handleLink}>
          {isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : invoicePayment.partnerName}
        </TableCellMiddle>
        <TableCellMiddle onClick={handleLink}>
          {isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : invoicePayment.routeName || '-'}
        </TableCellMiddle>
        <TableCellMiddle>
          {isLoading ? (
            <Skeleton variant='text' width={'100%'} height={25} />
          ) : (
            <div>
                <Typography variant='body2'>
                  {format(
                    new Date(
                      invoicePayment.paymentMethod === PaymentMethod.BANK_TRANSFER
                        ? ((invoicePayment.transferDate || invoicePayment.payDate) as Date | string)
                        : (invoicePayment.payDate as Date | string)
                    ),
                    'dd MMM yyyy'
                  )}
              </Typography>
              <NumberFormat value={invoicePayment.totalPay} prefix={'Rp'} thousandSeparator={true} displayType='text' />
            </div>
          )}
        </TableCellMiddle>
        <TableCellMiddle>
          {isLoading ? (
            <Skeleton variant='text' width={'100%'} height={25} />
          ) : (
            invoicePayment.paymentMethod && (
              <div>
                <Typography variant='inherit'>{`${invoicePayment.paymentMethod.toUpperCase()}${(invoicePayment.paymentMethod !==
                  PaymentMethod.RETURN &&
                  invoicePayment.useReturn &&
                  ' + RETURN') ||
                  ''}`}</Typography>
                {invoicePayment.paymentMethod === PaymentMethod.GIRO && (
                  <Typography variant='body2' style={{ color: BLUE_PRIMARY, fontSize: '12px' }}>
                    ({invoicePayment.status === PaymentStatus.PAID ? 'Pencairan : ' : 'Jatuh Tempo : '}
                    {format(
                      invoicePayment.status === PaymentStatus.PAID
                        ? new Date(invoicePayment.giroDate || invoicePayment.updatedAt!)
                        : new Date(invoicePayment.giroDueDate!),
                      'dd-MM-yyyy'
                    )}
                    )
                  </Typography>
                )}
              </div>
            )
          )}
        </TableCellMiddle>
        <TableCellMiddle onClick={handleLink}>
          {isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : invoicePayment.giroNumber}
        </TableCellMiddle>
        <TableCellMiddle align='right'>
          {isLoading ? (
            <Skeleton className={classes.cancel} variant='text' width={'100%'} height={25} />
          ) : invoicePayment.reject ? (
            <Typography className={classes.unpaid} align='center'>
              DITOLAK
            </Typography>
          ) : invoicePayment.paymentMethod !== PaymentMethod.GIRO ? (
            <Typography className={classes.accept}>DITERIMA</Typography>
          ) : invoicePayment.status === PaymentStatus.PAID ? (
            <Typography className={classes.paid}>SUDAH CAIR</Typography>
          ) : (
            <Typography className={classes.unpaid} align='center'>
              BELUM CAIR
            </Typography>
          )}
        </TableCellMiddle>
        <TableCellEnd align='right'>
          {isLoading ? (
            <Skeleton className={classes.cancel} variant='text' width={'100%'} height={25} />
          ) : invoicePayment.autorisasi ? (
            isHidden() ? null : (
              <>
                <Tooltip title='Autorisasi'>
                  <IconButton size='small' onClick={() => handleAction(true, invoicePayment.id)}>
                    <DescriptionOutlined fontSize='small' />
                  </IconButton>
                </Tooltip>

                {isFinance || isSuperAdmin ? (
                  <Tooltip title='Edit '>
                    <IconButton
                      size='small'
                      disabled={validAutorisasiDataList.length === 0}
                      onClick={() => {
                        history.push(`/pembayaran-penjualan/edit/${invoicePayment.id}`);
                      }}
                    >
                      <Edit fontSize='small' />
                    </IconButton>
                  </Tooltip>
                ) : null}
              </>
            )
          ) : null}{' '}
        </TableCellEnd>
      </TableRowCustom>

      <TableRowCollapse open={openCollapse && invoicePayment.id === indexCollapse && !isLoading} colSpan={10}>
        {invoicePayment.InvoicePiece.length > 0 && (
          <Table size='small' style={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Jenis Potongan</TableCell>
                <TableCell>Catatan</TableCell>
                <TableCell align='right'> Total Potongan</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicePayment.InvoicePiece.map((InvoicePiece, index) => (
                <TableRow key={index}>
                  <TableCell>{InvoicePiece.type === 'SHIPPING' ? 'Ongkos Kirim' : 'Lainnya'}</TableCell>
                  <TableCell>{InvoicePiece.note}</TableCell>
                  <TableCell align='right'>
                    <NumberFormat value={InvoicePiece.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        <Table size='small' style={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Invoice Number</TableCell>
              <TableCell>Nama Sales</TableCell>
              <TableCell>Tanggal Invoice</TableCell>
              <TableCell> Durasi Lunas</TableCell>
              {/* <TableCell> Total Invoice</TableCell> */}
              <TableCell align='right'> Total Pembayaran</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Skeleton variant='text' width='100%' height={25} />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {invoicePayment.InvoicePaymentMultiple.length > 0 &&
                  invoicePayment.InvoicePaymentMultiple.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{value.invoiceNumber}</TableCell>
                      <TableCell>{value.firstName ? `${value.firstName} ${value.lastName}` : '-'}</TableCell>
                      <TableCell>{value.orderDate ? format(new Date(value.orderDate), 'dd-MM-yyyy') : '-'}</TableCell>
                      <TableCell>{value.duration} Hari</TableCell>
                      {/* <TableCell>
                        <NumberFormat value={value.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                      </TableCell> */}
                      <TableCell align='right'>
                        <div>
                          <div>
                            <NumberFormat value={value.totalPay} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                          </div>
                          {Array.isArray(value.invoicePaymentMultiple) &&
                            value.invoicePaymentMultiple
                              //.filter(itm => (itm as any)?.paymentNumber !== invoicePayment.paymentNumber)
                              .map((itm, idx) => (
                                <div key={(itm as any)?.id ?? idx} className={classes.blurredText}>
                                  ({(itm as any).paymentNumber} :
                                  <NumberFormat value={(itm as any).totalPay || 0} prefix={'Rp'} thousandSeparator={true} displayType='text' />)
                                </div>
                              ))}

                          <div className={classes.blurredText}>
                            (Total Invoice:
                            <NumberFormat value={value.totalPrice || 0} prefix={'Rp'} thousandSeparator={true} displayType='text' />)
                          </div>
                          <div className={classes.blurredText}>
                            (Dari:
                            <NumberFormat value={value.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />)
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                {invoicePayment.InvoicePaymentMultiple.length > 0 && (
                  <TableRow style={{ fontWeight: 'bold' }}>
                    <TableCell style={{ fontWeight: 'bold' }}>TOTAL:</TableCell>
                    <TableCell> </TableCell>
                    <TableCell colSpan={5} align='right' style={{ fontWeight: 'bold' }}>
                      <NumberFormat
                        value={invoicePayment.InvoicePaymentMultiple.reduce((total, item) => total + (item.totalPay || 0), 0)}
                        prefix={'Rp'}
                        thousandSeparator={true}
                        displayType='text'
                      />
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
        {invoicePayment.useReturn && <TablePaymentReturn isLoading={isLoadingCollapse} data={invoicePaymentReturn} />}

        <Table size='small' style={{ width: '100%', marginTop: '16px' }}>
          <TableBody>
            <TableRow className={classes.totalRow}>
              <TableCell style={{ fontWeight: 'bold' }}>TOTAL DIBAYAR:</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>

              <TableCell align='right' style={{ fontWeight: 'bold' }}>
                <NumberFormat
                  value={
                    (invoicePayment.InvoicePaymentMultiple?.reduce((total, item) => total + (item.totalPay || 0), 0) || 0) -
                    (invoicePayment.useReturn ? invoicePaymentReturn?.reduce((total, item) => total + (item.totalPrice || 0), 0) || 0 : 0) -
                    (invoicePayment.otherPiece || 0)
                  }
                  prefix={'Rp'}
                  thousandSeparator={true}
                  displayType='text'
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {invoicePayment.otherPiece > 0 && (
          <Table size='small' style={{ width: '100%' }}>
            <TableBody>
              <TableRow>
                <TableCell>Potongan Lainya</TableCell>
                <TableCell> </TableCell>
                <TableCell align='right'>
                  <NumberFormat value={invoicePayment.otherPiece} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}

        {validAutorisasiDataList.length > 0 ? (
          <>
            <Typography style={{ marginTop: '24px', fontWeight: 600 }}>Autorisasi Detil</Typography>
            <Table size='small' style={{ width: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell component={'th'}>Level</TableCell>
                  <TableCell component={'th'}>Nama</TableCell>
                  <TableCell component={'th'}>Status</TableCell>
                  <TableCell component={'th'}>Tanggal</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {validAutorisasiDataList.map((v: any, idx: number) => (
                  <TableRow key={v?.level ?? idx}>
                    <TableCell>{v?.role ?? '-'}</TableCell>
                    <TableCell>{v?.actionBy ?? '-'}</TableCell>
                    <TableCell>{v?.status ?? '-'}</TableCell>
                    <TableCell>{v?.actionAt ?? '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        ) : null}
      </TableRowCollapse>
    </>
  );
};

export default BodyRow;
